import { render, staticRenderFns } from "./MonitoringPage.vue?vue&type=template&id=b01e11e8&scoped=true&"
import script from "./MonitoringPage.vue?vue&type=script&lang=js&"
export * from "./MonitoringPage.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringPage.vue?vue&type=style&index=0&id=b01e11e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01e11e8",
  null
  
)

export default component.exports